import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { BILLING_ON, fetchInvoicingQueue } from "@/lib/bf";

export default function BFAppTabs() {
  const [n, setN] = useState(0);
  useEffect(() => { if (BILLING_ON) fetchInvoicingQueue().then((l) => setN(l.filter((r) => r.billing.status !== "trimis").length)).catch(() => {}); }, []);
  if (!BILLING_ON) return null;
  return (
    <nav className="bf-apptabs" data-testid="bf-app-tabs">
      <NavLink to="/black-friday-admin" className={({ isActive }) => (isActive ? "is-on" : "")} data-testid="bf-tab-bf">Black Friday</NavLink>
      <NavLink to="/facturare-admin" className={({ isActive }) => (isActive ? "is-on" : "")} data-testid="bf-tab-facturare">
        Facturare <em>probă</em>{n > 0 && <b data-testid="bf-tab-facturare-badge">{n}</b>}
      </NavLink>
    </nav>
  );
}
